import React from "react";

import _ from "lodash";

import { formatNumericCurrency } from "utils";

import { CurrencyCode } from "consts";

import { FarmLevelFootprinting } from "models";

import { Table } from "components";

interface FormBonusesTableProps {
  formSubmissionBonuses: FarmLevelFootprinting["formSubmissionBonuses"];
  currency: CurrencyCode;
}

const FORMS = ["farm", "crop", "dairy", "beef"] as const;

type BonusRow = { year: string } & Partial<Record<(typeof FORMS)[number], number>>;

const FormBonusesTable: React.FC<FormBonusesTableProps> = ({ formSubmissionBonuses, currency }) => {
  const configuredForms = FORMS.filter((form) => formSubmissionBonuses[form]);
  const years = _.uniq(configuredForms.flatMap((form) => _.keys(formSubmissionBonuses[form]))).sort();

  return (
    <Table<BonusRow>
      data={years.map((year) => ({ year, ..._.fromPairs(configuredForms.map((form) => [form, formSubmissionBonuses[form]?.[year]])) }))}
      rowKey="year"
      pagination={false}
      locale={{ emptyText: "No bonuses configured" }}
      columns={[
        { title: "Year", dataIndex: "year" },
        ...configuredForms.map((form) => ({
          title: `${_.upperFirst(form)} form`,
          dataIndex: form,
          render: (amount?: number) => (amount === undefined ? "None" : formatNumericCurrency(amount, { currency, decimals: 0 })),
        })),
      ]}
    />
  );
};

export default FormBonusesTable;
